import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Pages/PageUnderDevelopment";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const PageUnderDevelopmentTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="PageUnderDevelopment">
      <TabletNotice page="PageUnderDevelopment" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default PageUnderDevelopmentTablet;